import { useCallback } from 'react';
import { useAuthContext } from '../providers/AuthProvider';

export function useAuth() {
  const {
    user,
    loading,
    error,
    isAuthenticated,
    signIn,
    signUp,
    signOut,
    signInWithProvider,
    sendPasswordResetEmail,
  } = useAuthContext();

  const signInWithGoogle = useCallback(() => signInWithProvider('google'), [signInWithProvider]);
  const signInWithGithub = useCallback(() => signInWithProvider('github'), [signInWithProvider]);

  return {
    user,
    loading,
    error,
    isAuthenticated,
    signIn,
    signUp,
    signOut,
    signInWithGoogle,
    signInWithGithub,
    sendPasswordResetEmail,
  };
}